import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import styles from "../../../common/forms/forms.module.css";
import { LabNotebook } from "../../types/LabNotebook";
import { FormHeader } from "../../../common/forms/FormHeader";
import { InputFormField } from "../../../common/formfields/InputFormField";
import { TextareaFormField } from "../../../common/formfields/TextareaFormField";
import { FormButtons } from "../../../common/forms/FormButtons";
import { ProjectsVirtualizedSelectForm } from "../../../common/forms/EntityForms/formsVirtualized/ProjectsVirtualizedSelectForm";
import { useCallback } from "react";
import { EntityFormProps } from "../../../common/entity/EntityInterfaces";

export interface LabNotebookFormValues extends Partial<LabNotebook> {}

export const LabNotebookForm = ({
  event,
  fieldLabels,
  loading,
  permissions,
  title,
  subtitle,
  initialValues,
  onSubmit,
  onCancel,
  submitButtonLabel,
}: EntityFormProps<"notebooks">) => {
  const LabNotebookFormSchema = yup.object().shape({
    name: yup.string().required("Notebook name is required").typeError("Notebook name is required"),
  });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm<LabNotebookFormValues>({
    values: initialValues,
    resolver: yupResolver(LabNotebookFormSchema),
  });

  const formValuesToEntity = useCallback(
    (entity: LabNotebookFormValues) => onSubmit({ ...entity } as LabNotebook),
    [onSubmit]
  );

  return (
    <>
      <FormHeader title={title} subtitle={subtitle} />
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
        autoComplete="off"
        className={`form-horizontal ${styles.form_holder}`}
      >
        <fieldset>
          <legend className="col-md-offset-2 col-md-10">Details</legend>
        </fieldset>

        <InputFormField
          id="name"
          label={fieldLabels.name}
          errors={errors}
          register={register}
          autoFocus={true}
          required
          placeholder="Enter name..."
        />

        <ProjectsVirtualizedSelectForm
          id="projects"
          label={fieldLabels.projects}
          control={control}
          showControls
          horizontal
          isMulti
          allowCreateEntity
          filters={{ currentUserHasAddPermission: true }}
        />

        <TextareaFormField
          id="description"
          label={fieldLabels.description}
          errors={errors}
          register={register}
          placeholder="Enter description..."
        />

        <FormButtons
          onClose={onCancel}
          onSubmit={handleSubmit(formValuesToEntity)}
          submitButtonLabel={submitButtonLabel || "Save changes"}
          disabled={isSubmitting}
          errors={errors}
          loading={loading}
        />
      </form>
    </>
  );
};
